//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { makeStyles } from '@material-ui/core/styles';
//import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
//import StoreIcon from '@material-ui/icons/Store';
import AirlineSeatReclineNormalIcon from '@material-ui/icons/AirlineSeatReclineNormal';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
import Fab from '@material-ui/core/Fab';
//import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import Tooltip from '@material-ui/core/Tooltip';
import Popover from '@material-ui/core/Popover';
import NavigationIcon from '@material-ui/icons/Navigation';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import Grid from "@material-ui/core/Grid";
import GridList from '@material-ui/core/GridList';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Divider from "@material-ui/core/Divider";


 /* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    card: {
        maxWidth: 600,
        //backgroundColor:'#e7d7f5',
      backgroundColor:'#f7e7cb',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px'
    },
    dividerColor1: {
        //marginTop: theme.spacing.unit * 3,
        color:"#40a339",
        backgroundColor:"#40a339",
    },

});


//'url(' + require('../../images/IMG_1.JPG')
class ExpandableTowCompanyDriverInformation extends React.Component {

            constructor(props) {
                super(props);
                this.state = {
                    age: '',
                    name: 'Farshid',
                    testnumber: '1232322',
                    labelWidth: 0,
                    open:false,
                };
                //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
                this.deleteImageClick = this.deleteImageClick.bind(this);
                this.editImageClick = this.editImageClick.bind(this);
                this.handleClickOpen = this.handleClickOpen.bind(this);
                this.handleClose = this.handleClose.bind(this);
                this.PaperComponent = this.PaperComponent.bind(this);
                this.handleDelete = this.handleDelete.bind(this);

            }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


            render() {
            const {classes} = this.props;
               // const classes2 = useStyles();

            return (
               
                < ExpansionPanel   className={classes.card}>
                    < ExpansionPanelSummary  style={{backgroundColor:'#e6d6ba'}} expandIcon = { < ExpandMoreIcon / > } aria-controls = "panel2a-content" id = "panel2a-header" >
                    <Grid container spacing={24}>
                            <Grid item xs={2} sm={2}>
                            <AirlineSeatReclineNormalIcon fontSize="large" color="black"></AirlineSeatReclineNormalIcon>
                
                            </Grid>
                            <Grid item xs={10} sm={10}>
                            <div>
                            < Typography  style={{display: 'inline-block'}}
                        variant = "h6" >
                            Driver - {this.props.info.firstname} {"   "} {this.props.info.lastname}
                        < /Typography>
                        </div>
                        </Grid>
                    </Grid>
                    < /ExpansionPanelSummary>
                    < ExpansionPanelDetails>
                            <Grid container spacing={24}>
                    
                                <Grid item xs={6} sm={6}>
                                        < Typography   style={{display: 'inline-block' , fontWeight:'bold'}}
                                        variant="button"
                                        >

                                       First Name:
                                < /Typography>
                                        <br/>
                                    < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "body1"
                                        >
                                        {this.props.info.firstname}
                                        < /Typography>
                                        </Grid>


                        

                            <Grid item xs={6} sm={6}>
                                    < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                                        variant = "button" >
                                    Last Name:
                                    < /Typography>
                                    <br/>
                                < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                                    variant = "body1" >
                                    {this.props.info.lastname}
                                < /Typography>
                            </Grid>


                        <Grid item xs={6} sm={6}>
                                < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                            variant = "button" >
                                Phone:
                        < /Typography>
                            <br/>
                            < Typography  style={{display: 'inline-block' , marginLeft: 15}}
                            variant = "body1" >
                                {this.props.info.phone}
                                < /Typography>
                            </Grid>
                    <Grid item xs={6} sm={6}>
                        < Typography  style={{display: 'inline-block' , fontWeight:'bold'}}
                                variant = "button" >
                        Email:
                        < /Typography>
                                <br/>
                         < Typography  style={{display: 'inline-block', marginLeft: 15}}
                            variant = "body1" >
                        {this.props.info.email}
                        < /Typography>
                    </Grid>
                    

                    
                    


                    
                    
                   
                    <Grid item xs={12} sm={12}>
                    <Divider className={classes.dividerColor1}></Divider>
                    </Grid>
                    <Grid item xs={2} sm={2}>
                <Tooltip title="Delete" aria-label="Delete">
                    <IconButton color="secondary" aria-label="delete" className={classes.extendedIcon}>
                    <DeleteIcon fontSize="large" onClick={() =>this.deleteImageClick(this.props.info)}/>
                    </IconButton>

                    </Tooltip>
                    </Grid>
                <Grid item xs={2} sm={2}>
                    <Tooltip title="Edit" aria-label="Edit">
                    <IconButton  color="primary" aria-label="edit" className={classes.extendedIcon}>
                    <EditIcon fontSize="large" onClick={() =>this.editImageClick(this.props.info)}/>
                    </IconButton>
                    </Tooltip>
                </Grid>

                    {/*
                    <Tooltip title="Add" aria-label="add">
                    <Fab color="primary" aria-label="add" className={ classes.margin}>
                    <AddIcon />
                    </Fab>
                    </Tooltip>
                    <Fab color="primary" aria-label="edit" className={classes.fab}>
                    <EditIcon fontSize="large" />
                    </Fab>
                    <Fab color="secondary" aria-label="delete" className={classes.fab}>
                    <DeleteIcon  fontSize="large"/>

                    </Fab>
                    */}
                    <Grid item xs={8} sm={8}>
                    </Grid>
                    </Grid>
                    < /ExpansionPanelDetails>


                <Dialog
                open={this.state.open}
                onClose={this.handleClose}
                PaperComponent={this.PaperComponent}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                    >
                    <DialogTitle id="alert-dialog-title"> Do you want to remove the driver {this.props.info.name} ?</DialogTitle>
                    <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    The driver,  {this.props.info.firstname},  at {this.props.info.lastname} will be removed from your profile.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.handleClose} color="primary">
                    Cancel
                    </Button>
                    <Button onClick={this.handleDelete} color="primary" autoFocus>
                Remove
                </Button>
                </DialogActions>
                </Dialog>
                < /ExpansionPanel>
                
        )
            ;
        }//end of render
}//End of class

ExpandableTowCompanyDriverInformation.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ExpandableTowCompanyDriverInformation);
